import { render, staticRenderFns } from "./operationalClassification.vue?vue&type=template&id=65ca94b1&scoped=true"
import script from "./operationalClassification.vue?vue&type=script&lang=js"
export * from "./operationalClassification.vue?vue&type=script&lang=js"
import style0 from "./operationalClassification.vue?vue&type=style&index=0&id=65ca94b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ca94b1",
  null
  
)

export default component.exports